<template>
  <div>
    <el-row>
      <el-col :span="8" v-if="currentType == 2">
        <el-link :href="vipExcelTemplateBsUrl" type="primary"
          >会员卡模板下载</el-link
        >
        <except-excel
          style="margin-top: 20px"
          :title="titleCardBs"
          @onExceptArray="onExceptCardArray"
        ></except-excel>
      </el-col>
      <el-col :span="8" v-else-if="currentType == 1">
        <el-link :href="vipExcelTemplateFcUrl" type="primary"
          >会员卡模板下载</el-link
        >
        <except-excel
          style="margin-top: 20px"
          :title="titleCardFc"
          @onExceptArray="onExceptCardArray"
        ></except-excel>
      </el-col>
    </el-row>
    <el-card shadow="always" style="margin-top: 14px">
      <el-row>
        <el-col :span="8"> 总数量 : {{ totalNum }} </el-col>
        <el-col :span="8"> 上传成功数 : {{ successNum }} </el-col>
        <el-col :span="8"> 上传失败数 : {{ failNum }} </el-col>
      </el-row>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 10px">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px">错误信息</span>
      </div>
      <div></div>
    </div>
    <el-card class="table-container" style="margin-top: 0px">
      <el-input
        type="textarea"
        readonly="true"
        :autosize="{ minRows: 15, maxRows: 20 }"
        placeholder=""
        v-model="errorInfo"
      >
      </el-input>
    </el-card>
  </div>
</template>

<script>
import ExceptExcel from "@/components/excel/ExceptExcel";
import { exportUserBuyCard, exportUserChild } from "@/api/export";
import messageUtils from "@/utils/messageUtils";
import globaldata from "@/utils/globaldata";
import { getStaticData } from "@/api/staticData";
import commonUtils from "@/utils/commonUtils";
export default {
  components: { ExceptExcel },
  props: {
    currentType: [Number, String],
  },
  data() {
    return {
      vipExcelTemplateFcUrl: "", //亲子游VIP模板下载
      vipExcelTemplateBsUrl: "", //基础游VIP模板下载
      titleCardFc: "导入B会员卡数据",
      titleCardBs: "导入A会员卡数据",
      timer: null,
      isInexport: false,
      childData: [],
      curExportChildIndex: -1,

      totalNum: 0, //总上传数量
      successNum: 0, //上传成功数量
      failNum: 0, //上传失败数量

      errorInfo: "",
      exportType: 0, //1 上传孩子数据 2 上传购卡
    };
  },
  mounted() {
    this.resetDataStart();
    this.initData();
  },
  methods: {
    initData() {
      getStaticData("").then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }

        this.vipExcelTemplateFcUrl = data.vipExcelTemplateFcUrl;
        this.vipExcelTemplateBsUrl = data.vipExcelTemplateBsUrl;
        console.log(
          "getStaticData",
          this.vipExcelTemplateBsUrl,
          this.vipExcelTemplateBsUrl
        );
      });
    },
    resetDataStart() {
      this.curExportChildIndex = -1;
      this.successNum = 0;
      this.failNum = 0;
      this.childData = [];
      clearInterval(this.timer);
      this.timer = null;
      this.isInexport = false;
      this.errorInfo = "";
      this.exportType = 0;
    },
    resetDataFinish() {
      this.curExportChildIndex = -1;
      this.childData = [];
      clearInterval(this.timer);
      this.timer = null;
      this.isInexport = false;
      this.exportType = 0;
    },
    onExceptCardArray(array, type) {
      console.log(array, type, "array, type");
      if (this.isInexport) {
        messageUtils.errorMsg(this, "正在上传数据，请稍后");
        return;
      }
      this.resetDataStart();
      array.map((v) => {
        let obj = {};

        obj.childName = v["会员姓名"];
        obj.childPetName = v["会员小名"];
        obj.childBirthday = v["会员生日"];
        obj.gender = v["会员性别"];
        obj.level = v["会员等级"];
        obj.userName = v["家长姓名"];
        obj.userPhone = v["家长手机号"];
        obj.address = v["社区"];
        obj.storeFrontId = globaldata.getAdminStore().storeFrontId;
        obj.cardName = v["卡名称"];
        obj.cardBussnessType = v["卡业务类型"];
        obj.totalClass = v["总正价课时"];
        obj.totalGiveClass = v["总赠送课时"];
        obj.remainingClass = v["剩余正价课时"];
        obj.remainingGiveClass = v["剩余赠送课时"];
        obj.valiedDay = v["有效期"];
        obj.totalPay = v["家长支付总金额"];
        obj.remTotalPay = v["剩余金额"];
        obj.useTimes = v["已经使用次数"];
        obj.remark = v["备注"];
        obj.templateId = this.currentType;
        this.childData.push(obj);
      });

      this.totalNum = this.childData.length;
      this.errorInfo = "开始上传......." + "\n";
      this.exportType = 2;
      this.timerCheckExport();
    },
    timerCheckExport() {
      this.timer = setInterval(this.doExportOne, 100);
    },
    doExportOne() {
      if (this.isInexport == true) {
        console.log("正在上传中,请等待");
        return;
      }
      this.curExportChildIndex = this.curExportChildIndex + 1;

      if (this.curExportChildIndex >= this.childData.length) {
        //完成了
        this.resetDataFinish();
        this.errorInfo += "上传结束......" + "\n";
        return;
      }
      this.isInexport = true;
      let param = this.childData[this.curExportChildIndex];
      if (this.exportType == 1) {
        this.onExportUserChild(param);
      } else if (this.exportType == 2) {
        this.onExportUserBuyCard(param);
      }
    },
    onExportUserBuyCard(param) {
      exportUserBuyCard(param).then((response) => {
        let data = response.data;
        if (data.success == true) {
          //上传一条成功
          this.onSuccess();
        } else {
          let mes = data.error;
          this.onFiled(mes);
        }
        this.isInexport = false;
      });
    },

    onExportUserChild(param) {
      exportUserChild(param).then((response) => {
        let data = response.data;
        if (data.success == true) {
          //上传一条成功
          this.onSuccess();
        } else {
          let mes = data.error;
          this.onFiled(mes);
        }
        this.isInexport = false;
      });
    },
    onSuccess() {
      this.successNum += 1;
    },
    onFiled(mes) {
      this.errorInfo =
        this.errorInfo +
        "第 " +
        (this.curExportChildIndex + 1) +
        " 条" +
        "上传失败 信息:" +
        mes;
      this.errorInfo += "\n";
      this.failNum += 1;
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/CardExport.vue